import * as yup from 'yup';
import { IncomeDTO, IncomeModel, IncomeType } from '../../api/useIncomeQuery';
import { getDefaultCustomBucketIndex } from '../../utils/getDefaultCustomBucketIndex';

export interface UpsertIncomeDTO extends RealEstateFormValues {
  clientId: string;
  id: string | null;
  IncomeType: IncomeType;
}

export interface RealEstateFormValues {
  AssociatedAssetId: string;
  Amount: number | null;
  IncomeGrowth: number | null;
  YearlyTaxableAmount: number | null;
  OrionManagementStyleId: number | null;
  CustomBucketIndex: number | null;
}

const defaultValues = {
  AssociatedAssetId: '',
  Amount: null,
  IncomeGrowth: null,
  YearlyTaxableAmount: null,
  OrionManagementStyleId: null,
  CustomBucketIndex: null,
};

export const dataToForm = (income: IncomeModel | null, data: IncomeDTO): RealEstateFormValues => {
  if (!income) {
    return defaultValues;
  }

  const { Options: options } = data;

  return {
    AssociatedAssetId: income.AssociatedAssetId,
    Amount: income.Amount,
    IncomeGrowth: income.IncomeGrowth,
    YearlyTaxableAmount: income.YearlyTaxableAmount,
    OrionManagementStyleId: income.OrionManagementStyleId,
    CustomBucketIndex: getDefaultCustomBucketIndex({
      isAssetBucketingByManagementStyle: options.AssetBucketingByManagementStyle,
      customBucketIndex: income.CustomBucketIndex,
      orionManagementStyleId: income.OrionManagementStyleId,
      managementStylesOptions: options.ManagementStyles,
    }),
  };
};

export const Validation = yup.object().shape({
  AssociatedAssetId: yup
    .string()
    .nullable()
    .required('Please specify an asset.'),
  Amount: yup
    .number()
    .nullable()
    .required('Please specify a yearly Amount'),
});
